// extracted by mini-css-extract-plugin
export default {"container":"craUY5Z7gd8Uscolwu_d","list":"iuoegRH6LVEI5A2Hfews"};